module.exports = __webpack_public_path__ + "media/homepage/student-news-6aff581e.webp";